import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgOnAir = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 21" {...props}>
    <path
      d="M1 4c1.567 1.67 2.35 3.668 2.35 5.992s-.783 4.32-2.35 5.991M4 0c2.533 2.866 3.8 6.24 3.8 10.122 0 3.883-1.267 7.253-3.8 10.111"
      fill="none"
      stroke="#7ED321"
    />
  </svg>
);
const Memo = memo(SvgOnAir);
export default Memo;
